import CardElementPhotoControlAssetUpload from './CardElementPhotoControlAssetUpload';

export default CardElementPhotoControlAssetUpload;
